module.exports = __webpack_public_path__ + "img/empreendimento-logo-34.afd540e8.png";